export { default } from './EmprestimoGarantiaCarroCreditoSeguro';
